/**
 * 개발용 성능 오버레이 (헌법 원칙 IV 측정 게이트).
 * FPS, draw call, 활성 rigid body 수, 물리 스텝 ms 표시. `?debug` 쿼리로 활성.
 */
import type * as THREE from 'three';
import type { PhysicsWorld } from '../physics/PhysicsWorld';

export class DevOverlay {
  readonly enabled: boolean;
  private el: HTMLElement | null = null;
  private frames = 0;
  private acc = 0;
  private fps = 0;

  constructor(
    private renderer: THREE.WebGLRenderer,
    private physics: PhysicsWorld,
  ) {
    this.enabled = new URLSearchParams(location.search).has('debug');
    if (!this.enabled) return;
    this.el = document.createElement('div');
    Object.assign(this.el.style, {
      position: 'fixed',
      bottom: '8px',
      left: '8px',
      zIndex: '999',
      font: '12px ui-monospace, monospace',
      color: '#8f8',
      background: 'rgba(0,0,0,0.6)',
      padding: '6px 8px',
      borderRadius: '6px',
      whiteSpace: 'pre',
      pointerEvents: 'none',
    });
    document.body.appendChild(this.el);
  }

  update(dt: number): void {
    if (!this.enabled || !this.el) return;
    this.frames++;
    this.acc += dt;
    if (this.acc >= 0.5) {
      this.fps = this.frames / this.acc;
      this.frames = 0;
      this.acc = 0;
      const info = this.renderer.info.render;
      this.el.textContent =
        `FPS ${this.fps.toFixed(0)}\n` +
        `draw calls ${info.calls}\n` +
        `bodies ${this.physics.dynamicCount}\n` +
        `physics ${this.physics.stepMs.toFixed(2)}ms`;
    }
  }
}
